/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchFacilitiesDictionaryResponse } from './search-facilities-dictionary-response';


export interface SearchFacilitiesDictionaryResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchFacilitiesDictionaryResponse> | null;
}

